import { getObjectTypedKeys } from '@augment-vir/common';
export function createRenderParams(element, eventsMap) {
    function updateState(newStatePartial) {
        getObjectTypedKeys(newStatePartial).forEach((stateKey) => {
            const newValue = newStatePartial[stateKey];
            const asyncState = element.asyncStateHandlerMap[stateKey];
            if (asyncState) {
                asyncState.setValue(newValue);
            }
            else {
                element.instanceState[stateKey] = newValue;
            }
        });
    }
    const renderParams = {
        dispatch: (event) => element.dispatchEvent(event),
        updateState,
        inputs: element.instanceInputs,
        host: element,
        state: element.instanceState,
        events: eventsMap,
    };
    return renderParams;
}
